import React from 'react';
import { Container, Title, Text, Button, Group } from '@mantine/core';
import { Link } from 'react-router-dom';
import { Card } from '@mantine/core';

const Home: React.FC = () => {
  return (
    <Container size="lg" py="xl">
      <Title order={1} mb="lg">
        Welcome to HMH Procurement
      </Title>
      <Text size="lg" mb="xl">
        A modern monorepo built with React, Fastify, and TypeScript.
      </Text>
      
      <Card mb="xl">
        <Title order={2} mb="md">
          Features
        </Title>
        <Text mb="md">
          This monorepo includes:
        </Text>
        <ul>
          <li>React frontend with Vite, Mantine, and Tailwind</li>
          <li>Fastify backend API</li>
          <li>Shared UI components</li>
          <li>TypeScript configuration</li>
          <li>ESLint and Prettier setup</li>
        </ul>
      </Card>

      <Group>
        <Button component={Link} to="/about" variant="filled">
          Learn More
        </Button>
        <Button variant="outline">
          Get Started
        </Button>
      </Group>
    </Container>
  );
};

export default Home; 